const L = {
  name: "Pin",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.0001 9.41008L22.4101 8.00008L21.3501 6.94008L20.7001 6.29008L17.7001 3.29008L17.0501 2.64008L15.9901 1.58008L14.5801 2.99008L15.5101 3.92008L10.7901 7.86008C8.36008 7.25008 5.69008 7.88008 3.79008 9.78008L3.29008 10.2801L2.58008 10.9901L3.29008 11.7001L7.08008 15.4901L1.58008 20.9901L2.99008 22.4001L8.49008 16.9001L12.2801 20.6901L12.9901 21.4001L13.7001 20.6901L14.2001 20.1901C16.1001 18.2901 16.7301 15.6101 16.1201 13.1901L20.0601 8.47008L20.9901 9.40008L21.0001 9.41008ZM14.2601 12.3101L13.9001 12.7401L14.0801 13.2701C14.6801 15.0501 14.3101 17.0801 12.9801 18.5601L5.42008 11.0001C6.90008 9.67008 8.93008 9.30008 10.7101 9.90008L11.2401 10.0801L11.6701 9.72008L16.9301 5.34008L18.6401 7.05008L14.2601 12.3101Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Pin
};
